const DEFAULT_PROFILE_IMAGE_URL =
  "https://toppng.com/uploads/preview/instagram-default-profile-picture-11562973083brycehrmyv.png";

export default DEFAULT_PROFILE_IMAGE_URL;
